function getThumb(url, size) {
  if (url) {
    let newUrl = url.slice(0, 50) + "q_70,w_" + size + "/" + url.slice(50);
    return newUrl;
  }
}

export default getThumb;
